import React from 'react';
import { Switch } from 'src/components/ui/switch';
import { Controller } from 'react-hook-form';

export const BaseFormToggleField = ({ control, name, label }) => {
  return (
    <div className="content">
      <div className="flex items-center gap-2.5">
        <Controller
          control={control}
          name={name}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Switch defaultChecked={value} checked={value} onCheckedChange={onChange} />
          )}
        />
        {label && <p className="font-semibold text-sm text-ebony opacity-80">{label}</p>}
      </div>
    </div>
  );
};
